import { render, staticRenderFns } from "./ArchiveDiscounts.vue?vue&type=template&id=68ac3da6"
import script from "./ArchiveDiscounts.vue?vue&type=script&lang=js"
export * from "./ArchiveDiscounts.vue?vue&type=script&lang=js"
import style0 from "./ArchiveDiscounts.vue?vue&type=style&index=0&id=68ac3da6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports